import { createSelector } from 'reselect'

const getCalendarState = state => state.calendar

/*
  NOTE(ebarrett): 
    Selector returns object of form:
      { [YYYY-MM-DD]: [packageId], ... } 
    for use in determining which dates should be highlighted in the date select
*/
export const selectValidDates = createSelector(getCalendarState, state => {
  const { data } = state
  if (!data?.forEach) return []

  const dates = {}

  data.forEach(item => {
    dates[item.date] = item.package
  })

  return dates
})
